var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"book-content__welcome"},[_c('div',{staticClass:"book-content__welcome-icon"},[_c('r-icon',{attrs:{"name":"ksodd-tables","size":64}})],1),_c('div',{staticClass:"book-content__welcome-text"},[_c('r-title',{attrs:{"type":"title-2","color-type":"subhead"}},[_vm._v(" "+_vm._s(_vm.$t("book:select-ds"))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }